<template>
    <VcCollapseItem
        :title="t('widget.layout')"
        name="layout"
        class="simple-collapse"
        :has-border="false"
    >
        <div>
            <VcFormItem>
                <VcCheckbox
                    :model-value="widgetLayoutModel.hideContainer ?? false"
                    @change="widgetLayoutModel.hideContainer = $event"
                >
                    {{ t('widget.hideContainer') }}
                </VcCheckbox>
            </VcFormItem>
            <VcFormItem
                :label="t('widget.config.cardTitleFontSize')"
            >
                <VcInputNumber
                    v-model="widgetLayoutModel.titleFontSize"
                    :max-value="titleCardFontSizes.max"
                    :min-value="titleCardFontSizes.min"
                    :step="1"
                    placeholder="0"
                />
            </VcFormItem>
            <VcFormItem
                :label="t('widget.config.cardValueFontSize')"
            >
                <VcInputNumber
                    v-model="widgetLayoutModel.valueFontSize"
                    :max-value="valueCardFontSizes.max"
                    :min-value="valueCardFontSizes.min"
                    :step="1"
                    placeholder="0"
                />
            </VcFormItem>
            <VcFormItem
                :label="t('widget.config.valueIconMinWidth')"
            >
                <VcInputNumber
                    v-model="widgetLayoutModel.valueIconMinWidth"
                    :max-value="valueCardMinWidth.max"
                    :min-value="valueCardMinWidth.min"
                    :step="1"
                    placeholder="0"
                />
            </VcFormItem>
            <div>
                <RedesignWidgetColors
                    v-model="widgetLayoutModel.colors"
                    :available-colors="availableColors"
                />
            </div>
        </div>
    </VcCollapseItem>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVModel } from '@vueuse/core'
import { VcFormItem, VcCheckbox, VcInputNumber, VcCollapseItem } from '@voicenter-team/voicenter-ui-plus'
import {
    titleCardFontSizes,
    valueCardFontSizes,
    valueCardMinWidth
} from '@/components/RedesignComponents/Widgets/widgets.enum'
import RedesignWidgetColors from '@/components/RedesignComponents/Widgets/Common/RedesignWidgetColors.vue'
import { WidgetLayout } from '@/types/dashboard'
import { getAllDefaultCardColors } from '@/enum/defaultWidgetSettings'

const props = defineProps<{
    modelValue: WidgetLayout
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: WidgetLayout): void
}>()

const { t } = useI18n()
const widgetLayoutModel = useVModel(props, 'modelValue', emit)

const availableColors = computed(() => {
    return getAllDefaultCardColors()
})
</script>
